import React from 'react'
import { SUBSCRIBE_BUTTON_INFO } from './constants'
import styled from 'styled-components'
import { useLocation } from '@reach/router'

const SubscribeButtonStyle = styled.button`
  border-radius: 8px;
  background-color: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  color: #FFF;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 32px;
  height: 32px;
  min-width: 100px;
  padding: 0 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &:hover {
    background-color: ${props => props.theme.v2.palette[ 'TAG1-800' ]};
    transition: .2s ease-in-out;
  }

  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 40px;
    height: 40px;
    width: 148px;
  }
`

const SubscribeButton = ( props ) => {
  const location = useLocation()
  const pageTextKey = location.pathname === '/' ? 'home' : 'remaining'

  return (
    <SubscribeButtonStyle
      className="subscribe-button__top"
      { ...props }
    >
      { SUBSCRIBE_BUTTON_INFO.text[ pageTextKey ] }
    </SubscribeButtonStyle>
  )
}

export default SubscribeButton
